<template>
    <a class="silhouetteCard" :href="`/Academic/Silhouette#Id=${propdata.Id}`">
        <div class="title">{{propdata.Title}}</div>
        <div class="image">
            <img :src="propdata.Cover" />
        </div>
    </a>
</template>

<script>
export default {
    name: "silhouettecard",
    components: {},
    props: {
        propdata: {
            type: Object
        }
    },
    data() {
        return {};
    },
    methods: {},
    computed: {},
    created() {},
    mounted() {},
    watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.silhouetteCard {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid #ccc;
    padding: 5px 5px 5px 10px;
    overflow: hidden;
    position: relative;
    color: #888;
    text-decoration: none;
    background-color: rgba(255, 255, 255, 0.3);
    transition: 0.35s;
}
.silhouetteCard + .silhouetteCard {
    margin-top: 20px;
}
.silhouetteCard:hover {
    color: #ee8b59;
    color: #fff;
}

.silhouetteCard:hover::after {
    width: 100%;
}
.silhouetteCard:after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 5px;
    height: 100%;
    background-color: #bab1a2;
    z-index: 50;
    transition: 0.5s;
}
.silhouetteCard .title {
    width: 48%;
    position: relative;
    z-index: 51;
    letter-spacing: 2px;
    line-height: 1.5;
}

.silhouetteCard .image {
    width: 48%;
    font-size: 0;
    overflow: hidden;
    position: relative;
    z-index: 51;
    padding-top: 30%;
    background-color: #fff;
}
.silhouetteCard .image img {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    transform: scale(1) translateY(-50%);
    /* max-width: 100%; */
    max-height: 100%;
    transition: 0.8s;
    margin: auto;
}
.silhouetteCard:hover img {
    transform: scale(1.2) translateY(-50%);
}
@media screen and(max-width:767px) {
    .silhouetteCard .image {
        padding-top: 23%;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/index/silhouetteCard.vue